import each from 'lodash/each';
import enquire from 'enquire.js';

export default breakpoints => {
    each(breakpoints, breakpoint => {
        enquire.register(breakpoint.selector, {
            match() {
                if (breakpoint.match) {
                    breakpoint.match();
                }
            },
            unmatch() {
                if (breakpoint.unmatch) {
                    breakpoint.unmatch();
                }
            },
            setup() {
                if (breakpoint.setup) {
                    breakpoint.setup();
                }
            },
            deferSetup: true,
            destroy() { }
        });
    });
};
